"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("DeleteTrashOutlined", React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M17.3 23.1H5.9L4.7 8h13.8zM2.9 4.3H8l.6-3h5.9l.6 3h5v2.1H2.9z", stroke: "currentColor", fill: "none", strokeLinecap: "round" }),
    React.createElement("path", { d: "M8.1 19.2l7-7M15.1 19.2l-7-7", stroke: "currentColor", fill: "none", strokeLinecap: "round" })));
//# sourceMappingURL=DeleteTrashOutlined.js.map